/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft account unlinked successfully.`)
};

const zh_hans1_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 账号已解除绑定。`)
};

const zh_hant1_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 帳號已解除綁定。`)
};

const fr_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte Minecraft dissocié avec succès.`)
};

const de_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft-Konto erfolgreich getrennt.`)
};

const ja_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraftアカウントの連携を解除しました。`)
};

const ko_settings_minecraft_unlinked_success = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 계정 연동이 해제되었습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_unlinked_success = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_unlinked_success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_unlinked_success", locale)
	if (locale === "en") return en_settings_minecraft_unlinked_success(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_unlinked_success(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_unlinked_success(inputs)
	if (locale === "fr") return fr_settings_minecraft_unlinked_success(inputs)
	if (locale === "de") return de_settings_minecraft_unlinked_success(inputs)
	if (locale === "ja") return ja_settings_minecraft_unlinked_success(inputs)
	return ko_settings_minecraft_unlinked_success(inputs)
};